import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import Collapse from 'react-bootstrap/Collapse';
import Button from 'react-bootstrap/Button';
import { Formik } from 'formik';
import * as yup from 'yup';
import { NormalPerson } from './NormalPerson';
import { JuristicPerson } from './JuristicPerson';
import { SuccessModal } from '../modals';
import moment from 'moment';
import { memberHandler, masterHandler } from '../../../redux/handlers';
import _ from 'lodash';

export function CustomerInfo() {
  const { customerID, businessSlug } = useParams();
  const dispatch = useDispatch();

  const entityTypes = useSelector(state => state.master.entityTypes || []);
  const entityStructuresByType = useSelector(state => state.master.entityStructuresByType || []);

  const { provinces } = useSelector(state => state.master);

  const [juristicDistricts, setJuristicDistricts] = useState([]);
  const [juristicSubDistricts, setJuristicSubDistricts] = useState([]);
  const [normalDistricts, setNormalDistricts] = useState([]);
  const [normalSubDistricts, setNormalSubDistricts] = useState([]);

  const [entityStructures, setEntityStructures] = useState([]);
  const [juristicEntityStructures, setJuristicEntityStructures] = useState([]);
  const [naturalEntityStructures, setNaturalEntityStructures] = useState([]);

  const [juristicPrefixNames, setJuristicPrefixNames] = useState([]);
  const [normalPrefixNames, setNormalPrefixNames] = useState([]);
  const [naturalPrefixNames, setNaturalPrefixNames] = useState([]);

  const [modalsuccess, setModalsuccess] = useState(false);
  const [textsuccess, setTextsuccess] = useState('');
  const [formdisabled, setFormdisabled] = useState(false);
  const [cardOpen1, setCardOpen1] = useState(true);
  const [cardOpen2, setCardOpen2] = useState(true);
  const [cardOpen3, setCardOpen3] = useState(true);
  const [loading, setLoading] = useState(false);

  const schema = yup.object().shape({
    code: yup.string().required('กรุณากรอกรหัสลูกค้า'),

    first_name_th: yup.string().when('customerType', {
      is: 2,
      then: schema => schema.required('กรุณากรอกชื่อภาษาไทย'),
      otherwise: schema => schema.notRequired()
    }),

    last_name_th: yup.string().when('customerType', {
      is: 2,
      then: schema => schema.required('กรุณากรอกนามสกุลภาษาไทย'),
      otherwise: schema => schema.notRequired()
    }),

    phone_number: yup.string().when('customerType', {
      is: 2,
      then: schema =>
        schema.required('กรุณากรอกเบอร์โทรศัพท์').matches(/^[0-9]+$/, 'เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น'),
      otherwise: schema => schema.notRequired()
    }),

    tel: yup.string().test('phone-format', 'เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น', function (value) {
      if (!value) return true;
      return /^[0-9]+$/.test(value);
    }),

    juristic_phone_number: yup.string().test('phone-format', 'เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น', function (value) {
      if (!value) return true;
      return /^[0-9]+$/.test(value);
    }),

    juristic_tel: yup.string().test('phone-format', 'เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น', function (value) {
      if (!value) return true;
      return /^[0-9]+$/.test(value);
    }),

    person_phone_number: yup.string().test('phone-format', 'เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น', function (value) {
      if (!value) return true;
      return /^[0-9]+$/.test(value);
    }),

    person_tel: yup.string().test('phone-format', 'เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น', function (value) {
      if (!value) return true;
      return /^[0-9]+$/.test(value);
    }),

    company_name_th: yup.string().when('customerType', {
      is: 1,
      then: schema => schema.required('กรุณากรอกชื่อบริษัทภาษาไทย'),
      otherwise: schema => schema.notRequired()
    }),

    juristic_entity_structure_id: yup
      .number()
      .when(['juristic_tax_number', 'juristic_company_name', 'juristic_address'], {
        is: (tax, company, address) => tax || company || address,
        then: schema => schema.required('กรุณาเลือกประเภทนิติบุคคล'),
        otherwise: schema => schema.notRequired()
      }),

    email: yup.string().test('email-format', 'รูปแบบอีเมลไม่ถูกต้อง', function (value) {
      if (!value) return true;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    }),

    juristic_email: yup.string().test('email-format', 'รูปแบบอีเมลไม่ถูกต้อง', function (value) {
      if (!value) return true;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    }),

    person_email: yup.string().test('email-format', 'รูปแบบอีเมลไม่ถูกต้อง', function (value) {
      if (!value) return true;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    }),

    tax_number: yup.string().test('tax-format', 'หมายเลขผู้เสียภาษีต้องเป็นตัวเลข 13 หลัก', function (value) {
      if (!value) return true;
      return /^[0-9]{13}$/.test(value);
    }),

    juristic_tax_number: yup.string().test('tax-format', 'หมายเลขผู้เสียภาษีต้องเป็นตัวเลข 13 หลัก', function (value) {
      if (!value) return true;
      return /^[0-9]{13}$/.test(value);
    }),

    person_card_number: yup
      .string()
      .test('tax-format', 'หมายเลขประจำตัวประชาชนต้องเป็นตัวเลข 13 หลัก', function (value) {
        if (!value) return true;
        return /^[0-9]{13}$/.test(value);
      }),

    juristic_branch_vat_code: yup.string().when('juristic_taxable_entity_type', {
      is: 'BRANCH',
      then: schema =>
        schema
          .required('กรุณากรอกหมายเลขสาขา')
          .test('branch-format', 'หมายเลขสาขาต้องเป็นตัวเลขเท่านั้น', function (value) {
            if (!value) return false;
            return /^[0-9]+$/.test(value);
          }),
      otherwise: schema => schema.notRequired()
    }),

    birthday: yup.string().test('date-format', 'รูปแบบวันที่ต้องเป็น DD/MM/YYYY', function (value) {
      if (!value) return true;
      return /^(\d{2}\/\d{2}\/\d{4})$/.test(value);
    }),

    totalPoint: yup
      .number()
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null) return undefined;
        return value;
      })
      .min(0, 'คะแนนต้องมีค่ามากกว่าหรือเท่ากับ 0'),

    total_debt: yup
      .number()
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null) return undefined;
        return value;
      })
      .min(0, 'ยอดหนี้รวมต้องมีค่ามากกว่าหรือเท่ากับ 0'),

    age: yup.string().test('age-format', 'อายุต้องเป็นตัวเลขเท่านั้น', function (value) {
      if (!value) return true;
      return /^[0-9]*$/.test(value);
    }),

    juristic_taxable_entity_type: yup
      .string()
      .oneOf(['UNSPECIFIED', 'HEADQUARTERS', 'BRANCH'], 'กรุณาเลือกประเภทสำนักงาน')
  });

  const [formdata, setFormdata] = useState({
    entity_type_id: null,
    entity_structure_id: null,
    prefix_name_id: null,
    gender_id: null,
    member_group_id: null,
    code: '',
    totalPoint: 0,
    line_uid: '',
    facebook: '',
    first_name_th: '',
    last_name_th: '',
    first_name_en: '',
    last_name_en: '',
    company_name_th: '',
    company_name_en: '',
    email: '',
    phone_number: '',
    tel: '',
    tax_number: '',
    birth_date: '',
    sub_district_id: null,
    address: '',
    total_debt: 0,

    juristic_taxable_entity_type: 'UNSPECIFIED',
    juristic_branch_vat_code: '',
    juristic_entity_type_id: null,
    juristic_entity_structure_id: null,
    juristic_prefix_name_id: null,
    juristic_prefix_name_other: '',
    juristic_tax_number: '',
    juristic_vat_code: '',
    juristic_first_name: '',
    juristic_last_name: '',
    juristic_company_name: '',
    juristic_address: '',
    juristic_sub_district_id: null,
    juristic_phone_number: '',
    juristic_tel: '',
    juristic_email: '',

    person_card_number: '',
    person_entity_type_id: null,
    person_entity_structure_id: null,
    person_prefix_name_id: null,
    person_prefix_name_other: '',
    person_first_name: '',
    person_last_name: '',
    person_address: '',
    person_sub_district_id: null,
    person_phone_number: '',
    person_tel: '',
    person_email: '',

    is_status: true,
    is_active: true,

    customerType: 1,
    birthday: '',
    age: '',

    jpProvince: '',
    jpDistrict: '',
    jpPostalcode: '',
    npProvince: '',
    npDistrict: '',
    npPostalcode: ''
  });

  const [identitycard, setIdentitycard] = useState(['', '', '', '', '', '', '', '', '', '', '', '', '']);

  const entityTypeOptions =
    entityTypes?.map(item => ({
      value: item.id.toString(),
      label: item.name,
      code: item.code
    })) || [];

  const entityStructureOptions =
    entityStructuresByType?.map(item => ({
      value: item.id.toString(),
      label: item.name,
      code: item.code
    })) || [];

  const optionsBusinesstype = entityStructuresByType
    .filter(item => item.entity_type_id === 1)
    .map(item => ({
      value: item.id.toString(),
      label: item.name,
      code: item.code
    }));

  useEffect(() => {
    const loadMasterData = async () => {
      try {
        const [_, __, juristicEntityTypes, naturalEntityTypes] = await Promise.all([
          dispatch(masterHandler.getEntityTypes()),
          dispatch(masterHandler.getProvinces()),
          dispatch(masterHandler.getEntityStructuresByEntityType('JURISTIC')),
          dispatch(masterHandler.getEntityStructuresByEntityType('NATURAL'))
        ]);

        const _juristicStructures =
          juristicEntityTypes?.map(item => ({
            value: item.id.toString(),
            label: item.name,
            code: item.code
          })) || [];
        setJuristicEntityStructures(_juristicStructures);

        const _naturalStructures =
          naturalEntityTypes?.map(item => ({
            value: item.id.toString(),
            label: item.name,
            code: item.code
          })) || [];
        setNaturalEntityStructures(_naturalStructures);
      } catch (error) {
        console.error('Error loading master data:', error);
      }
    };

    loadMasterData();
  }, [dispatch]);

  const handleEntityTypeChange = async (selectedOption, setFieldValue) => {
    try {
      const entityTypeCode = selectedOption?.code || '';
      const entityTypeId = selectedOption?.value || null;

      setFieldValue('entity_type_id', entityTypeId ? parseInt(entityTypeId) : null);
      setFieldValue('entity_structure_id', null);
      setFieldValue('prefix_name_id', null);

      setFieldValue('customerType', entityTypeId ? parseInt(entityTypeId) : 1);
      setFieldValue('company_name_th', '');
      setFieldValue('company_name_en', '');
      setFieldValue('first_name_th', '');
      setFieldValue('last_name_th', '');

      setNormalPrefixNames([]);

      if (entityTypeCode) {
        const entityStructures = await dispatch(masterHandler.getEntityStructuresByEntityType(entityTypeCode));
        setEntityStructures(
          entityStructures?.map(item => ({
            value: item.id.toString(),
            label: item.name,
            code: item.code
          })) || []
        );
      }
    } catch (error) {
      console.error('Error handling entity type change:', error);
    }
  };

  const handleEntityStructureChange = async (selectedOption, setFieldValue, values) => {
    try {
      const entityStructureCode = selectedOption.code;
      const entityStructureId = selectedOption.value;

      setFieldValue('entity_structure_id', parseInt(entityStructureId));
      setFieldValue('prefix_name_id', null);

      setFieldValue('company_name_th', '');
      setFieldValue('first_name_th', '');
      setFieldValue('last_name_th', '');

      const currentEntityType = entityTypeOptions?.find(option => option.value === values.entity_type_id?.toString());

      if (currentEntityType?.code) {
        const prefixResponse = await dispatch(
          masterHandler.getPrefixNamesByTypeAndStructure(currentEntityType.code, entityStructureCode)
        );

        const _normalPrefixes =
          prefixResponse?.map(item => ({
            value: item.id,
            label: item.name
          })) || [];

        setJuristicPrefixNames(prefixResponse);
        setNormalPrefixNames(_normalPrefixes);
      }
    } catch (error) {
      console.error('Error handling entity structure change:', error);
    }
  };

  const handleNaturalEntityStructureChange = async (selectedOption, setFieldValue) => {
    try {
      const naturalEntityType = entityTypes?.find(et => et.code === 'NATURAL');

      setFieldValue('person_entity_type_id', naturalEntityType ? naturalEntityType.id : null);
      setFieldValue('person_entity_structure_id', parseInt(selectedOption.value));
      setFieldValue('person_prefix_name_id', null);
      setNaturalPrefixNames([]);

      const prefixResponse = await dispatch(
        masterHandler.getPrefixNamesByTypeAndStructure('NATURAL', selectedOption.code)
      );

      const _naturalPrefixes =
        prefixResponse?.map(item => ({
          value: item.id,
          label: item.name
        })) || [];
      setNaturalPrefixNames(_naturalPrefixes);
    } catch (error) {
      console.error('Error handling natural entity structure change:', error);
    }
  };

  const handleJuristicStructureChange = async (selectedOption, setFieldValue) => {
    try {
      const juristicEntityType = entityTypes?.find(et => et.code === 'JURISTIC');

      setFieldValue('juristic_entity_type_id', juristicEntityType ? juristicEntityType.id : null);
      setFieldValue('juristic_entity_structure_id', parseInt(selectedOption.value));
      setFieldValue('juristic_prefix_name_id', null);

      const prefixResponse = await dispatch(
        masterHandler.getPrefixNamesByTypeAndStructure('JURISTIC', selectedOption.code)
      );

      const _juristicPrefixes =
        prefixResponse?.map(item => ({
          value: item.id,
          label: item.name,
          first_name: item.first_name || '',
          last_name: item.last_name || ''
        })) || [];
      setJuristicPrefixNames(_juristicPrefixes);

      if (prefixResponse && prefixResponse.length > 0) {
        const firstPrefix = prefixResponse[0];
        setFieldValue('juristic_prefix_name_id', firstPrefix.id);
        setFieldValue('juristic_first_name', firstPrefix.first_name || '');
        setFieldValue('juristic_last_name', firstPrefix.last_name || '');
      }
    } catch (error) {
      console.error('Error handling juristic structure change:', error);
    }
  };

  const handleProvinceChange = async (selectedOption, setFieldValue, isJuristic = true) => {
    const provinceField = isJuristic ? 'jpProvince' : 'npProvince';
    const districtField = isJuristic ? 'jpDistrict' : 'npDistrict';
    const postalField = isJuristic ? 'jpPostalcode' : 'npPostalcode';

    setFieldValue(provinceField, selectedOption.value);
    setFieldValue(districtField, '');
    setFieldValue(postalField, '');

    try {
      const districtsResponse = await dispatch(masterHandler.getDistricts(selectedOption.value));
      if (isJuristic) {
        setJuristicDistricts(districtsResponse || []);
        setJuristicSubDistricts([]);
      } else {
        setNormalDistricts(districtsResponse || []);
        setNormalSubDistricts([]);
      }
    } catch (error) {
      console.error('Error loading districts:', error);
    }
  };

  const handleDistrictChange = async (selectedOption, setFieldValue, isJuristic = true) => {
    const districtField = isJuristic ? 'jpDistrict' : 'npDistrict';
    const postalField = isJuristic ? 'jpPostalcode' : 'npPostalcode';

    setFieldValue(districtField, selectedOption.value);
    setFieldValue(postalField, '');

    try {
      const subDistrictsResponse = await dispatch(masterHandler.getSubDistricts(selectedOption.value));
      if (isJuristic) {
        setJuristicSubDistricts(subDistrictsResponse || []);
      } else {
        setNormalSubDistricts(subDistrictsResponse || []);
      }
    } catch (error) {
      console.error('Error loading sub districts:', error);
    }
  };

  const handleSubDistrictChange = (selectedOption, setFieldValue, isJuristic = true) => {
    const subDistrictField = isJuristic ? 'juristic_sub_district_id' : 'person_sub_district_id';
    const postalField = isJuristic ? 'jpPostalcode' : 'npPostalcode';

    setFieldValue(subDistrictField, selectedOption.value);

    const subDistrictsArray = isJuristic ? juristicSubDistricts : normalSubDistricts;
    const subDistrict = subDistrictsArray?.find(s => s.id.toString() === selectedOption.value);

    if (subDistrict) {
      setFieldValue(postalField, subDistrict.zip_code);
    }
  };

  const mapApiResponseToFormData = apiData => {
  const member = apiData;

  let formattedBirthday = '';
  if (member.birth_date) {
    const birthDate = moment(member.birth_date);
    if (birthDate.isValid()) {
      formattedBirthday = birthDate.format('DD/MM/YYYY');
    }
  }

  let jpProvince = '';
  let jpDistrict = '';
  let jpPostalcode = '';

  if (member.juristic_sub_district?.district) {
    jpProvince = member.juristic_sub_district.district.province_id?.toString() || '';
    jpDistrict = member.juristic_sub_district.district.id?.toString() || '';
    jpPostalcode = member.juristic_sub_district.zip_code || '';
  }

  let npProvince = '';
  let npDistrict = '';
  let npPostalcode = '';

  if (member.subDistrict?.district) {
    npProvince = member.subDistrict.district.province_id?.toString() || '';
    npDistrict = member.subDistrict.district.id?.toString() || '';
    npPostalcode = member.subDistrict.zip_code || '';
  } else if (member.person_sub_district?.district) {
    npProvince = member.person_sub_district.district.province_id?.toString() || '';
    npDistrict = member.person_sub_district.district.id?.toString() || '';
    npPostalcode = member.person_sub_district.zip_code || '';
  } else if (!member.person_sub_district_id && member.juristic_sub_district?.district) {
    npProvince = jpProvince;
    npDistrict = jpDistrict;
    npPostalcode = jpPostalcode;
  }

  // ปรับปรุงการดึง entity_type_id
  // ถ้า entity_type_id เป็น null ให้เอาจาก entity_structure.entity_type_id แทน
  const effectiveEntityTypeId = member.entity_type_id || member.entity_structure?.entity_type_id || null;

  return {
    ...member,
    customerType: effectiveEntityTypeId, // ใช้ effective entity_type_id
    birthday: formattedBirthday,
    age: '',

    jpProvince: jpProvince,
    jpDistrict: jpDistrict,
    jpPostalcode: jpPostalcode,

    npProvince: npProvince,
    npDistrict: npDistrict,
    npPostalcode: npPostalcode,

    entity_type_id: effectiveEntityTypeId, // ใช้ effective entity_type_id
    entity_structure_id: member.entity_structure_id || null,
    prefix_name_id: member.prefix_name_id || null,
    gender_id: member.gender_id || null,
    member_group_id: member.member_group_id || null,
    code: member.code || '',
    totalPoint: member.totalPoint || 0,
    line_uid: member.line_uid || '',
    facebook: member.facebook || '',
    first_name_th: member.first_name_th || '',
    last_name_th: member.last_name_th || '',
    first_name_en: member.first_name_en || '',
    last_name_en: member.last_name_en || '',
    company_name_th: member.company_name_th || '',
    company_name_en: member.company_name_en || '',
    email: member.email || '',
    phone_number: member.phone_number || '',
    tel: member.tel || '',
    tax_number: member.tax_number || '',
    birth_date: member.birth_date || '',
    sub_district_id: member.sub_district_id || null,
    address: member.address || '',
    total_debt: member.total_debt || 0,
    juristic_taxable_entity_type: member.juristic_taxable_entity_type || 'UNSPECIFIED',
    juristic_branch_vat_code: member.juristic_branch_vat_code || '',
    juristic_entity_type_id: member.juristic_entity_type_id || null,
    juristic_entity_structure_id: member.juristic_entity_structure_id || null,
    juristic_prefix_name_id: member.juristic_prefix_name_id || null,
    juristic_prefix_name_other: member.juristic_prefix_name_other || '',
    juristic_tax_number: member.juristic_tax_number || '',
    juristic_vat_code: member.juristic_vat_code || '',
    juristic_first_name: member.juristic_first_name || '',
    juristic_last_name: member.juristic_last_name || '',
    juristic_company_name: member.juristic_company_name || '',
    juristic_address: member.juristic_address || '',
    juristic_sub_district_id: member.juristic_sub_district_id || null,
    juristic_phone_number: member.juristic_phone_number || '',
    juristic_tel: member.juristic_tel || '',
    juristic_email: member.juristic_email || '',
    person_card_number: member.person_card_number || '',
    person_entity_type_id: member.person_entity_type_id || null,
    person_entity_structure_id: member.person_entity_structure_id || null,
    person_prefix_name_id: member.person_prefix_name_id || null,
    person_prefix_name_other: member.person_prefix_name_other || '',
    person_first_name: member.person_first_name || '',
    person_last_name: member.person_last_name || '',
    person_address: member.person_address || '',
    person_sub_district_id: member.person_sub_district_id || null,
    person_phone_number: member.person_phone_number || '',
    person_tel: member.person_tel || '',
    person_email: member.person_email || '',
    is_status: member.is_status !== undefined ? member.is_status : true,
    is_active: member.is_active !== undefined ? member.is_active : true
  };
};

  const mapFormDataToApiRequest = values => {
    let formattedBirthDate = null;
    if (values.birthday) {
      const birthDate = moment(values.birthday, 'DD/MM/YYYY');
      if (birthDate.isValid()) {
        formattedBirthDate = birthDate.format('YYYY-MM-DD');
      }
    } else if (values.birth_date) {
      formattedBirthDate = values.birth_date;
    }

    const juristicEntityType = entityTypes?.find(et => et.code === 'JURISTIC');

    const apiFields = {
      ..._.omit(values, [
        'id',
        'business_id',
        'created_at',
        'updated_at',
        'business',

        'totaltotalPoint',
        'totalSale',
        'billAmount',
        'buyFirstAndLatestBill',

        'customerType',
        'birthday',
        'age',
        'jpProvince',
        'jpDistrict',
        'jpPostalcode',
        'npProvince',
        'npDistrict',
        'npPostalcode',
        'entity_structure',
        'entity_type',
        'company_prefix',
        'company_suffix',
        'juristic_entity_structure_id',
        'juristic_entity_type',
        'juristic_sub_district',
        'person_entity_structure_id',
        'person_sub_district',
        'totalPoint'
      ]),
      birth_date: formattedBirthDate,

      juristic_entity_type_id: juristicEntityType ? juristicEntityType.id : values.juristic_entity_type_id
    };

    return apiFields;
  };

  const handleinputTab = (e, index) => {
    const updateItem = [...identitycard];
    updateItem[index] = e.target.value;
    setIdentitycard(updateItem);
  };

  const fetchMemberData = async () => {
  try {
    setLoading(true);
    const response = await dispatch(memberHandler.getMemberById(customerID));
    if (response) {
      if (response.juristic_prefix_name_id) {
        const prefixData = await dispatch(masterHandler.getPrefixNameById(response.juristic_prefix_name_id));
        if (prefixData && prefixData.entity_structure_id) {
          response.juristic_entity_structure_id = prefixData.entity_structure_id;
        }
      }

      if (response.person_prefix_name_id) {
        const personPrefixData = await dispatch(masterHandler.getPrefixNameById(response.person_prefix_name_id));
        if (personPrefixData && personPrefixData.entity_structure_id) {
          response.person_entity_structure_id = personPrefixData.entity_structure_id;
        }
      }

      const mappedData = mapApiResponseToFormData(response);
      setFormdata(mappedData);

      if (mappedData.tax_number) {
        setIdentitycard(mappedData.tax_number.split(''));
      }

      // โหลด entity structures และ prefix names สำหรับ entity type หลัก
      if (response.entity_structure && mappedData.entity_type_id) {
        console.log("entityTypes : ", entityTypes);
        
        const entityType = entityTypes?.find(et => et.id === mappedData.entity_type_id);
        const entityTypeCode = entityType?.code || response.entity_type?.code;
        const entityStructureCode = response.entity_structure.code;

        console.log("entityTypeCode : ",entityTypeCode);
        
        if (entityTypeCode) {
          const [entityStructures, prefixResponse] = await Promise.all([
            dispatch(masterHandler.getEntityStructuresByEntityType(entityTypeCode)),
            dispatch(masterHandler.getPrefixNamesByTypeAndStructure(entityTypeCode, entityStructureCode))
          ]);

          setEntityStructures(
            entityStructures?.map(item => ({
              value: item.id.toString(),
              label: item.name,
              code: item.code
            })) || []
          );

          if (entityTypeCode === 'JURISTIC') {
            const _juristicPrefixes =
              prefixResponse?.map(item => ({
                value: item.id,
                label: item.name,
                first_name: item.first_name || '',
                last_name: item.last_name || ''
              })) || [];
            setJuristicPrefixNames(_juristicPrefixes);
          } else {
            const _normalPrefixes =
              prefixResponse?.map(item => ({
                value: item.id,
                label: item.name
              })) || [];
            setNormalPrefixNames(_normalPrefixes);
          }
        }
      }

      const loadAddressData = async () => {
        try {
          const juristicProvinceToLoad = new Set();
          const juristicDistrictsToLoad = new Set();
          const normalProvinceToLoad = new Set();
          const normalDistrictsToLoad = new Set();

          if (response.juristic_sub_district?.district) {
            const juristicProvince = response.juristic_sub_district.district.province_id;
            const juristicDistrict = response.juristic_sub_district.district.id;

            juristicProvinceToLoad.add(juristicProvince);
            juristicDistrictsToLoad.add(juristicDistrict);
          }

          if (response.subDistrict?.district) {
            const mainProvince = response.subDistrict.district.province_id;
            const mainDistrict = response.subDistrict.district.id;

            normalProvinceToLoad.add(mainProvince);
            normalDistrictsToLoad.add(mainDistrict);
          }

          if (mappedData.jpProvince) {
            juristicProvinceToLoad.add(parseInt(mappedData.jpProvince));
            if (mappedData.jpDistrict) {
              juristicDistrictsToLoad.add(parseInt(mappedData.jpDistrict));
            }
          }

          if (mappedData.npProvince) {
            normalProvinceToLoad.add(parseInt(mappedData.npProvince));
            if (mappedData.npDistrict) {
              normalDistrictsToLoad.add(parseInt(mappedData.npDistrict));
            }
          }

          for (const provinceId of juristicProvinceToLoad) {
            const districtsResponse = await dispatch(masterHandler.getDistricts(provinceId));
            setJuristicDistricts(districtsResponse || []);
          }

          for (const districtId of juristicDistrictsToLoad) {
            const subDistrictsResponse = await dispatch(masterHandler.getSubDistricts(districtId));
            setJuristicSubDistricts(subDistrictsResponse || []);
          }

          for (const provinceId of normalProvinceToLoad) {
            const districtsResponse = await dispatch(masterHandler.getDistricts(provinceId));
            setNormalDistricts(districtsResponse || []);
          }

          for (const districtId of normalDistrictsToLoad) {
            const subDistrictsResponse = await dispatch(masterHandler.getSubDistricts(districtId));
            setNormalSubDistricts(subDistrictsResponse || []);
          }

          // โหลด natural entity structures และ prefix names สำหรับ person section
          if (response.person_entity_structure_id) {
            const allNaturalStructures = await dispatch(masterHandler.getEntityStructuresByEntityType('NATURAL'));
            const naturalEntityStructure = allNaturalStructures?.find(
              nes => nes.id === response.person_entity_structure_id
            );

            if (naturalEntityStructure) {
              const prefixResponse = await dispatch(
                masterHandler.getPrefixNamesByTypeAndStructure('NATURAL', naturalEntityStructure.code)
              );

              const _naturalPrefixes =
                prefixResponse?.map(item => ({
                  value: item.id,
                  label: item.name
                })) || [];
              setNaturalPrefixNames(_naturalPrefixes);
            }
          }
        } catch (error) {
          console.error('Error loading address data:', error);
        }
      };

      await loadAddressData();
      setFormdisabled(true);
    }
  } catch (error) {
    console.error('Error fetching member data:', error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    if (customerID && entityTypes?.length > 0) {
      fetchMemberData();
    }
  }, [customerID, entityTypes]);

  const handleFormSubmit = async values => {
    try {
      setLoading(true);
      const identitycardString = identitycard.join('');
      const updatedValues = {
        ...values,
        tax_number: identitycardString
      };

      const requestBody = mapFormDataToApiRequest(updatedValues);

      if (customerID && businessSlug) {
        const response = await dispatch(memberHandler.updateMember(businessSlug, customerID, requestBody));

        if (response) {
          setTextsuccess('บันทึกข้อมูลลูกค้าสำเร็จ');
          setModalsuccess(true);
          setFormdisabled(true);
          fetchMemberData();
        }
      } else {
        console.error('Missing customerID or businessSlug');
      }
    } catch (error) {
      console.error('Error updating member:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  console.log("entityStructures : ",entityStructures);
  

  return (
    <div>
      <Formik enableReinitialize initialValues={formdata} validationSchema={schema} onSubmit={handleFormSubmit}>
        {({ handleSubmit, handleChange, errors, touched, values, setFieldValue }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <fieldset disabled={formdisabled}>
              <div className="card card-st-3 mb-3">
                <div className="card-body px-xl-3">
                  <button
                    type="button"
                    className="btn w-100 text-start btn-collapse"
                    onClick={() => setCardOpen1(!cardOpen1)}
                    aria-controls="collapse1"
                    aria-expanded={cardOpen1}
                  >
                    <div className="tc-8 fs-18 fw-bold px-3">ข้อมูลทั่วไป</div>
                  </button>
                  <Collapse in={cardOpen1}>
                    <div className="mt-3" id="collapse1">
                      <div className="px-3 mb-4">
                        <div className="row gx-xl-4">
                          <div className="col-xl-3 col-md-6">
                            <Form.Group className="mb-3 form-st-3 pb-1">
                              <Form.Label className="mb-1">ประเภทกิจการ</Form.Label>
                              <Select
                                name="entity_type_id"
                                onChange={selectedOption => handleEntityTypeChange(selectedOption, setFieldValue)}
                                className={`w-100 select-st-1 ${
                                  touched.entity_type_id && errors.entity_type_id ? 'is-invalid' : ''
                                }`}
                                options={entityTypeOptions}
                                placeholder="เลือกประเภทกิจการ"
                                value={entityTypeOptions.find(item => item.value === values.entity_type_id?.toString())}
                              />
                              {touched.entity_type_id && errors.entity_type_id && (
                                <div className="invalid-feedback d-block">{errors.entity_type_id}</div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-xl-3 col-md-6">
                            <Form.Group className="mb-3 form-st-3 pb-1">
                              <Form.Label className="mb-1">รูปแบบกิจการ</Form.Label>
                              <Select
                                key={`entity_structure_${values.entity_type_id || 'none'}`}
                                name="entity_structure_id"
                                onChange={selectedOption =>
                                  handleEntityStructureChange(selectedOption, setFieldValue, values)
                                }
                                className={`w-100 select-st-1 ${
                                  touched.entity_structure_id && errors.entity_structure_id ? 'is-invalid' : ''
                                }`}
                                options={entityStructures}
                                placeholder="เลือกรูปแบบกิจการ"
                                value={entityStructures.find(
                                  item => item.value === values.entity_structure_id?.toString()
                                )}
                                isDisabled={!values.entity_type_id}
                              />
                              {touched.entity_structure_id && errors.entity_structure_id && (
                                <div className="invalid-feedback d-block">{errors.entity_structure_id}</div>
                              )}
                            </Form.Group>
                          </div>
                        </div>
                      </div>

                      {values.customerType === 1 ? (
                        <JuristicPerson
                          setFieldValue={setFieldValue}
                          values={values}
                          prefixNames={juristicPrefixNames}
                          handleChange={handleChange}
                          errors={errors}
                          touched={touched}
                          identitycard={identitycard}
                          handleinputTab={handleinputTab}
                        />
                      ) : (
                        <NormalPerson
                          setFieldValue={setFieldValue}
                          values={values}
                          prefixNames={normalPrefixNames}
                          handleChange={handleChange}
                          errors={errors}
                          touched={touched}
                          identitycard={identitycard}
                          handleinputTab={handleinputTab}
                        />
                      )}
                    </div>
                  </Collapse>
                </div>
              </div>

              <div className="card card-st-3 mb-3">
                <div className="card-body px-xl-3">
                  <button
                    type="button"
                    className="btn w-100 text-start btn-collapse"
                    onClick={() => setCardOpen2(!cardOpen2)}
                    aria-controls="collapse2"
                    aria-expanded={cardOpen2}
                  >
                    <div className="tc-8 fs-18 fw-bold px-3">ข้อมูลออกใบกำกับภาษี (นิติบุคคล)</div>
                  </button>
                  <Collapse in={cardOpen2}>
                    <div id="collapse2">
                      <div>
                        <div className="pt-3 px-3">
                          <div className="row gx-xl-4">
                            <div className="col-xl-4 col-md-6">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">หมายเลขผู้เสียภาษี 13 หลัก</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="juristic_tax_number"
                                  className="form-control"
                                  placeholder="หมายเลขผู้เสียภาษี 13 หลัก"
                                  maxLength={13}
                                  value={values.juristic_tax_number}
                                  onChange={handleChange}
                                  isInvalid={touched.juristic_tax_number && !!errors.juristic_tax_number}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.juristic_tax_number && errors.juristic_tax_number}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                            <div className="col-xl-8 col-md-8 row">
                              <div className="mb-3 pt-3 col-auto mt-1">
                                <Form.Check
                                  inline
                                  label="ไม่ระบุ"
                                  name="juristic_taxable_entity_type"
                                  type="radio"
                                  id={`inline-juristic-type-1`}
                                  className="form-check-st-2 tc-7"
                                  checked={values.juristic_taxable_entity_type === 'UNSPECIFIED'}
                                  onChange={() => {
                                    setFieldValue('juristic_taxable_entity_type', 'UNSPECIFIED');
                                  }}
                                />
                                <Form.Check
                                  inline
                                  label="สำนักงานใหญ่"
                                  name="juristic_taxable_entity_type"
                                  type="radio"
                                  id={`inline-juristic-type-2`}
                                  className="form-check-st-2 tc-7"
                                  checked={values.juristic_taxable_entity_type === 'HEADQUARTERS'}
                                  onChange={() => {
                                    setFieldValue('juristic_taxable_entity_type', 'HEADQUARTERS');
                                  }}
                                />
                                <Form.Check
                                  inline
                                  label="สาขา"
                                  name="juristic_taxable_entity_type"
                                  type="radio"
                                  id={`inline-juristic-type-3`}
                                  className="form-check-st-2 tc-7"
                                  checked={values.juristic_taxable_entity_type === 'BRANCH'}
                                  onChange={() => {
                                    setFieldValue('juristic_taxable_entity_type', 'BRANCH');
                                  }}
                                />
                              </div>
                              <div className="col-auto">
                                <Form.Group className="mb-2 form-st-3 pb-1">
                                  <Form.Label className="mb-1">หมายเลขสาขา</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="juristic_branch_vat_code"
                                    className="form-control"
                                    placeholder="หมายเลขสาขา"
                                    value={
                                      values.juristic_taxable_entity_type === 'BRANCH'
                                        ? values.juristic_branch_vat_code
                                        : ''
                                    }
                                    onChange={handleChange}
                                    isInvalid={touched.juristic_branch_vat_code && !!errors.juristic_branch_vat_code}
                                    disabled={!(values.juristic_taxable_entity_type === 'BRANCH')}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {touched.juristic_branch_vat_code && errors.juristic_branch_vat_code}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                            </div>

                            <div className="col-xl-3 col-md-6">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">
                                  ประเภทนิติบุคคล <span className="text-danger ms-1"> *</span>
                                </Form.Label>
                                <Select
                                  name="juristic_entity_structure_id"
                                  onChange={selectedOption => {
                                    handleJuristicStructureChange(selectedOption, setFieldValue);
                                  }}
                                  className={`w-100 select-st-1 ${
                                    touched.juristic_entity_structure_id && errors.juristic_entity_structure_id
                                      ? 'is-invalid'
                                      : ''
                                  }`}
                                  options={juristicEntityStructures}
                                  placeholder="เลือกประเภทนิติบุคคล"
                                  value={juristicEntityStructures.find(
                                    item => item.value === values.juristic_entity_structure_id?.toString()
                                  )}
                                />
                                {touched.juristic_entity_structure_id && errors.juristic_entity_structure_id && (
                                  <div className="invalid-feedback d-block">{errors.juristic_entity_structure_id}</div>
                                )}
                              </Form.Group>
                            </div>

                            <div className="col-xl-2 col-md-12">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">คำนำหน้า </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="juristic_first_name"
                                  className="form-control"
                                  placeholder="คำนำหน้า"
                                  value={values.juristic_first_name}
                                  onChange={handleChange}
                                  isInvalid={touched.juristic_first_name && !!errors.juristic_first_name}
                                  disabled={true}
                                  style={{ backgroundColor: '#f8f9fa' }}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.juristic_first_name && errors.juristic_first_name}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                            <div className="col-xl-5 col-md-12">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">ชื่อกิจการ </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="juristic_company_name"
                                  className="form-control"
                                  placeholder="ชื่อกิจการ"
                                  value={values.juristic_company_name}
                                  onChange={handleChange}
                                  isInvalid={touched.juristic_company_name && !!errors.juristic_company_name}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.juristic_company_name && errors.juristic_company_name}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>

                            <div className="col-xl-2 col-md-12">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">คำลงท้าย </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="juristic_last_name"
                                  className="form-control"
                                  placeholder="คำลงท้าย"
                                  value={values.juristic_last_name}
                                  onChange={handleChange}
                                  isInvalid={touched.juristic_last_name && !!errors.juristic_last_name}
                                  disabled={true}
                                  style={{ backgroundColor: '#f8f9fa' }}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.juristic_last_name && errors.juristic_last_name}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>

                            <div className="col-xl-12 col-md-12">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">ที่อยู่</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="juristic_address"
                                  className="form-control"
                                  placeholder="ที่อยู่"
                                  value={values.juristic_address}
                                  onChange={handleChange}
                                  isInvalid={touched.juristic_address && !!errors.juristic_address}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.juristic_address && errors.juristic_address}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>

                            <div className="col-12">
                              <div className="row gx-xl-4">
                                <div className="col-xl-6">
                                  <Form.Group className="mb-2 form-st-3 pb-1">
                                    <Form.Label className="mb-1">จังหวัด</Form.Label>
                                    <Select
                                      name="jpProvince"
                                      onChange={selectedOption => {
                                        handleProvinceChange(selectedOption, setFieldValue, true);
                                      }}
                                      className={`w-100 select-st-1 ${
                                        touched.jpProvince && errors.jpProvince ? 'is-invalid' : ''
                                      }`}
                                      options={
                                        provinces?.map(p => ({
                                          value: p.id.toString(),
                                          label: p.name_th
                                        })) || []
                                      }
                                      placeholder="เลือกจังหวัด"
                                      value={
                                        provinces
                                          ?.filter(p => p.id.toString() === values.jpProvince)
                                          .map(p => ({
                                            value: p.id.toString(),
                                            label: p.name_th
                                          }))[0] || null
                                      }
                                    />
                                    {touched.jpProvince && errors.jpProvince && (
                                      <div className="invalid-feedback d-block">{errors.jpProvince}</div>
                                    )}
                                  </Form.Group>
                                </div>
                                <div className="col-xl-6">
                                  <Form.Group className="mb-2 form-st-3 pb-1">
                                    <Form.Label className="mb-1">เขต/อำเภอ</Form.Label>
                                    <Select
                                      name="jpDistrict"
                                      onChange={selectedOption => {
                                        handleDistrictChange(selectedOption, setFieldValue, true);
                                      }}
                                      className={`w-100 select-st-1 ${
                                        touched.jpDistrict && errors.jpDistrict ? 'is-invalid' : ''
                                      }`}
                                      options={
                                        juristicDistricts?.map(d => ({
                                          value: d.id.toString(),
                                          label: d.name_th
                                        })) || []
                                      }
                                      placeholder="เลือกเขต/อำเภอ"
                                      value={
                                        juristicDistricts
                                          ?.filter(d => d.id.toString() === values.jpDistrict)
                                          .map(d => ({
                                            value: d.id.toString(),
                                            label: d.name_th
                                          }))[0] || null
                                      }
                                      isDisabled={!values.jpProvince}
                                    />
                                    {touched.jpDistrict && errors.jpDistrict && (
                                      <div className="invalid-feedback d-block">{errors.jpDistrict}</div>
                                    )}
                                  </Form.Group>
                                </div>
                                <div className="col-xl-6">
                                  <Form.Group className="mb-2 form-st-3 pb-1">
                                    <Form.Label className="mb-1">แขวง/ตำบล</Form.Label>
                                    <Select
                                      name="juristic_sub_district_id"
                                      onChange={selectedOption => {
                                        handleSubDistrictChange(selectedOption, setFieldValue, true);
                                      }}
                                      className={`w-100 select-st-1 ${
                                        touched.juristic_sub_district_id && errors.juristic_sub_district_id
                                          ? 'is-invalid'
                                          : ''
                                      }`}
                                      options={
                                        juristicSubDistricts?.map(s => ({
                                          value: s.id.toString(),
                                          label: s.name_th,
                                          zip_code: s.zip_code
                                        })) || []
                                      }
                                      placeholder="เลือกแขวง/ตำบล"
                                      value={
                                        juristicSubDistricts
                                          ?.filter(s => s.id.toString() === values.juristic_sub_district_id?.toString())
                                          .map(s => ({
                                            value: s.id.toString(),
                                            label: s.name_th
                                          }))[0] || null
                                      }
                                      isDisabled={!values.jpDistrict}
                                    />
                                    {touched.juristic_sub_district_id && errors.juristic_sub_district_id && (
                                      <div className="invalid-feedback d-block">{errors.juristic_sub_district_id}</div>
                                    )}
                                  </Form.Group>
                                </div>
                                <div className="col-xl-6">
                                  <Form.Group className="mb-2 form-st-3 pb-1">
                                    <Form.Label className="mb-1">รหัสไปรษณีย์</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="jpPostalcode"
                                      className="form-control"
                                      placeholder="รหัสไปรษณีย์"
                                      value={values.jpPostalcode}
                                      disabled
                                      isInvalid={touched.jpPostalcode && !!errors.jpPostalcode}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {touched.jpPostalcode && errors.jpPostalcode}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                              </div>
                            </div>

                            <div className="col-xxl-3 col-xl-3 col-md-6">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">เบอร์โทรศัพท์</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="juristic_tel"
                                  className="form-control"
                                  placeholder="เบอร์โทรศัพท์"
                                  value={values.juristic_tel}
                                  onChange={handleChange}
                                  isInvalid={touched.juristic_tel && !!errors.juristic_tel}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.juristic_tel && errors.juristic_tel}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>

                            <div className="col-xxl-3 col-xl-3 col-md-6">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">เบอร์มือถือ</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="juristic_phone_number"
                                  className="form-control"
                                  placeholder="เบอร์มือถือ"
                                  value={values.juristic_phone_number}
                                  onChange={handleChange}
                                  isInvalid={touched.juristic_phone_number && !!errors.juristic_phone_number}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.juristic_phone_number && errors.juristic_phone_number}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>

                            <div className="col-xxl-6 col-xl-3 col-md-6">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">E-mail</Form.Label>
                                <Form.Control
                                  type="email"
                                  name="juristic_email"
                                  className="form-control"
                                  placeholder="E-mail"
                                  value={values.juristic_email}
                                  onChange={handleChange}
                                  isInvalid={touched.juristic_email && !!errors.juristic_email}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.juristic_email && errors.juristic_email}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              </div>

              <div className="card card-st-3 mb-3">
                <div className="card-body px-xl-3">
                  <button
                    type="button"
                    className="btn w-100 text-start btn-collapse"
                    onClick={() => setCardOpen3(!cardOpen3)}
                    aria-controls="collapse3"
                    aria-expanded={cardOpen3}
                  >
                    <div className="tc-8 fs-18 fw-bold px-3">ข้อมูลออกใบกำกับภาษี (บุคคลธรรมดา)</div>
                  </button>
                  <Collapse in={cardOpen3}>
                    <div id="collapse3">
                      <div>
                        <div className="pt-3 px-3">
                          <div className="row gx-xl-4">
                            <div className="col-xl-4 col-md-6">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">หมายเลขผู้เสียภาษี 13 หลัก</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="person_card_number"
                                  className="form-control"
                                  placeholder="หมายเลขผู้เสียภาษี 13 หลัก"
                                  maxLength={13}
                                  value={values.person_card_number}
                                  onChange={handleChange}
                                  isInvalid={touched.person_card_number && !!errors.person_card_number}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.person_card_number && errors.person_card_number}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>

                            <div className="col-xl-3 col-md-6">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">ประเภทบุคคลธรรมดา</Form.Label>
                                <Select
                                  name="person_entity_structure_id"
                                  onChange={selectedOption => {
                                    setFieldValue('person_entity_structure_id', parseInt(selectedOption.value));
                                    handleNaturalEntityStructureChange(selectedOption, setFieldValue);
                                  }}
                                  className={`w-100 select-st-1 ${
                                    touched.person_entity_structure_id && errors.person_entity_structure_id
                                      ? 'is-invalid'
                                      : ''
                                  }`}
                                  options={naturalEntityStructures}
                                  placeholder="เลือกประเภทบุคคลธรรมดา"
                                  value={naturalEntityStructures.find(
                                    item => item.value === values.person_entity_structure_id?.toString()
                                  )}
                                />
                                {touched.person_entity_structure_id && errors.person_entity_structure_id && (
                                  <div className="invalid-feedback d-block">{errors.person_entity_structure_id}</div>
                                )}
                              </Form.Group>
                            </div>

                            <div className="col-xl-2 col-md-4">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">คำนำหน้า</Form.Label>
                                <Select
                                  key={`person_prefix_${values.person_entity_structure_id || 'none'}`}
                                  name="person_prefix_name_id"
                                  onChange={selectedOption => {
                                    setFieldValue('person_prefix_name_id', selectedOption?.value || null);
                                  }}
                                  className={`w-100 select-st-1 ${
                                    touched.person_prefix_name_id && errors.person_prefix_name_id ? 'is-invalid' : ''
                                  }`}
                                  options={naturalPrefixNames}
                                  placeholder="เลือกคำนำหน้า"
                                  value={
                                    naturalPrefixNames.find(item => item.value === values.person_prefix_name_id) || null
                                  }
                                  isDisabled={!values.person_entity_structure_id}
                                  isClearable={true}
                                />
                                {touched.person_prefix_name_id && errors.person_prefix_name_id && (
                                  <div className="invalid-feedback d-block">{errors.person_prefix_name_id}</div>
                                )}
                              </Form.Group>
                            </div>
                            <div className="col-xl-3 col-md-4">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">ชื่อ </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="person_first_name"
                                  className="form-control"
                                  placeholder="กรอกชื่อภาษาไทย"
                                  value={values.person_first_name}
                                  onChange={handleChange}
                                  isInvalid={touched.person_first_name && !!errors.person_first_name}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.person_first_name && errors.person_first_name}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                            <div className="col-xl-3 col-md-4">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">นามสกุล </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="person_last_name"
                                  className="form-control"
                                  placeholder="กรอกนามสกุลภาษาไทย"
                                  value={values.person_last_name}
                                  onChange={handleChange}
                                  isInvalid={touched.person_last_name && !!errors.person_last_name}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.person_last_name && errors.person_last_name}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>

                            <div className="col-xl-12 col-md-12">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">ที่อยู่</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="person_address"
                                  className="form-control"
                                  placeholder="ที่อยู่"
                                  value={values.person_address}
                                  onChange={handleChange}
                                  isInvalid={touched.person_address && !!errors.person_address}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.person_address && errors.person_address}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>

                            <div className="col-12">
                              <div className="row gx-xl-4">
                                <div className="col-xl-6">
                                  <Form.Group className="mb-2 form-st-3 pb-1">
                                    <Form.Label className="mb-1">จังหวัด</Form.Label>
                                    <Select
                                      name="npProvince"
                                      onChange={selectedOption => {
                                        handleProvinceChange(selectedOption, setFieldValue, false);
                                      }}
                                      className={`w-100 select-st-1 ${
                                        touched.npProvince && errors.npProvince ? 'is-invalid' : ''
                                      }`}
                                      options={
                                        provinces?.map(p => ({
                                          value: p.id.toString(),
                                          label: p.name_th
                                        })) || []
                                      }
                                      placeholder="เลือกจังหวัด"
                                      value={
                                        provinces
                                          ?.filter(p => p.id.toString() === values.npProvince)
                                          .map(p => ({
                                            value: p.id.toString(),
                                            label: p.name_th
                                          }))[0] || null
                                      }
                                    />
                                    {touched.npProvince && errors.npProvince && (
                                      <div className="invalid-feedback d-block">{errors.npProvince}</div>
                                    )}
                                  </Form.Group>
                                </div>
                                <div className="col-xl-6">
                                  <Form.Group className="mb-2 form-st-3 pb-1">
                                    <Form.Label className="mb-1">เขต/อำเภอ</Form.Label>
                                    <Select
                                      name="npDistrict"
                                      onChange={selectedOption => {
                                        handleDistrictChange(selectedOption, setFieldValue, false);
                                      }}
                                      className={`w-100 select-st-1 ${
                                        touched.npDistrict && errors.npDistrict ? 'is-invalid' : ''
                                      }`}
                                      options={
                                        normalDistricts?.map(d => ({
                                          value: d.id.toString(),
                                          label: d.name_th
                                        })) || []
                                      }
                                      placeholder="เลือกเขต/อำเภอ"
                                      value={
                                        normalDistricts
                                          ?.filter(d => d.id.toString() === values.npDistrict)
                                          .map(d => ({
                                            value: d.id.toString(),
                                            label: d.name_th
                                          }))[0] || null
                                      }
                                      isDisabled={!values.npProvince}
                                    />
                                    {touched.npDistrict && errors.npDistrict && (
                                      <div className="invalid-feedback d-block">{errors.npDistrict}</div>
                                    )}
                                  </Form.Group>
                                </div>
                                <div className="col-xl-6">
                                  <Form.Group className="mb-2 form-st-3 pb-1">
                                    <Form.Label className="mb-1">แขวง/ตำบล</Form.Label>
                                    <Select
                                      name="person_sub_district_id"
                                      onChange={selectedOption => {
                                        handleSubDistrictChange(selectedOption, setFieldValue, false);
                                      }}
                                      className={`w-100 select-st-1 ${
                                        touched.person_sub_district_id && errors.person_sub_district_id
                                          ? 'is-invalid'
                                          : ''
                                      }`}
                                      options={
                                        normalSubDistricts?.map(s => ({
                                          value: s.id.toString(),
                                          label: s.name_th,
                                          zip_code: s.zip_code
                                        })) || []
                                      }
                                      placeholder="เลือกแขวง/ตำบล"
                                      value={
                                        normalSubDistricts
                                          ?.filter(s => s.id.toString() === values.person_sub_district_id?.toString())
                                          .map(s => ({
                                            value: s.id.toString(),
                                            label: s.name_th
                                          }))[0] || null
                                      }
                                      isDisabled={!values.npDistrict}
                                    />
                                    {touched.person_sub_district_id && errors.person_sub_district_id && (
                                      <div className="invalid-feedback d-block">{errors.person_sub_district_id}</div>
                                    )}
                                  </Form.Group>
                                </div>
                                <div className="col-xl-6">
                                  <Form.Group className="mb-2 form-st-3 pb-1">
                                    <Form.Label className="mb-1">รหัสไปรษณีย์</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="npPostalcode"
                                      className="form-control"
                                      placeholder="รหัสไปรษณีย์"
                                      value={values.npPostalcode}
                                      disabled
                                      isInvalid={touched.npPostalcode && !!errors.npPostalcode}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {touched.npPostalcode && errors.npPostalcode}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                              </div>
                            </div>

                            <div className="col-xxl-3 col-xl-3 col-md-6">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">เบอร์โทรศัพท์</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="person_tel"
                                  className="form-control"
                                  placeholder="เบอร์โทรศัพท์"
                                  value={values.person_tel}
                                  onChange={handleChange}
                                  isInvalid={touched.person_tel && !!errors.person_tel}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.person_tel && errors.person_tel}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>

                            <div className="col-xxl-3 col-xl-3 col-md-6">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">เบอร์มือถือ</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="person_phone_number"
                                  className="form-control"
                                  placeholder="เบอร์มือถือ"
                                  value={values.person_phone_number}
                                  onChange={handleChange}
                                  isInvalid={touched.person_phone_number && !!errors.person_phone_number}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.person_phone_number && errors.person_phone_number}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>

                            <div className="col-xxl-6 col-xl-3 col-md-6">
                              <Form.Group className="mb-2 form-st-3 pb-1">
                                <Form.Label className="mb-1">E-mail</Form.Label>
                                <Form.Control
                                  type="email"
                                  name="person_email"
                                  className="form-control"
                                  placeholder="E-mail"
                                  value={values.person_email}
                                  onChange={handleChange}
                                  isInvalid={touched.person_email && !!errors.person_email}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {touched.person_email && errors.person_email}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              </div>
            </fieldset>

            <div className="text-end pb-4 pe-3">
              {formdisabled ? (
                <Button type="button" className="btn-st-3 mx-3" onClick={() => setFormdisabled(false)}>
                  แก้ไข
                </Button>
              ) : (
                <div className="text-end pt-3 btn-group-control">
                  <Button type="button" className="btn-st-6 me-3 btn" onClick={() => setFormdisabled(true)}>
                    ยกเลิก
                  </Button>
                  <Button type="submit" className="btn-st-3" disabled={loading}>
                    {loading ? 'กำลังบันทึก...' : 'บันทึก'}
                  </Button>
                </div>
              )}
            </div>
          </Form>
        )}
      </Formik>

      <SuccessModal modal={{ open: modalsuccess }} onHide={() => setModalsuccess(false)} textsuccess={textsuccess} />
    </div>
  );
}
